var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var Legends_1;
import React, { Children, Component, Fragment } from 'react';
import { Alignment, Placement } from '@philips-internal/oswald-ui-constants';
import { AwesomeComponent, ComponentType, Container } from '@philips-internal/oswald-ui-core';
import { bool, expression, number, oneOf, string } from '@philips-internal/oswald-ui-core/lib/component/prop-types/index.js';
import { MessageService } from '@philips-internal/oswald-ui-core/lib/services/index.js';
import { classNames, enumValues, getLostProps, isEnumValid, isMobileResolution, propagateProps } from '@philips-internal/oswald-ui-utils';
import { Link } from '../link/link.js';
import { Popover } from '../popover/popover.js';
import { SlideUpPanel } from '../slide-up-panel/slide-up-panel.js';
import { InlineLegend } from './components/inline-legend.js';
import { LegendsItems } from './components/legends-items.js';
import { LegendsAPI } from './legends-api.js';
import { LegendsMode, LegendsSize } from './legends-constants.js';
import { LegendsProvider } from './legends-context.js';
import './legends.css';
const LegendsContainer = {
    name: '',
};
let Legends = Legends_1 = class Legends extends Component {
    constructor() {
        super(...arguments);
        this.state = {
            open: false,
        };
        this.renderMode = {
            [LegendsMode.INLINE]: () => this.renderInline(),
            [LegendsMode.POPOVER]: () => isMobileResolution() ? this.renderSlideUpPanel() : this.renderPopover(),
        };
        this.onToggleClick = () => {
            this.setState((prevState) => ({ open: !prevState.open }));
        };
    }
    renderInline() {
        const { hideExpression = Legends_1.defaultProps.hideExpression, previewAmount = Legends_1.defaultProps.previewAmount, showExpression = Legends_1.defaultProps.showExpression, showPreview = Legends_1.defaultProps.showPreview, } = this.props;
        const { open } = this.state;
        return (React.createElement(InlineLegend, { hideExpression: hideExpression, onClick: this.onToggleClick, open: open, previewAmount: previewAmount, showExpression: showExpression, showPreview: showPreview }));
    }
    renderSlideUpPanel() {
        const { open } = this.state;
        return (React.createElement(Fragment, null,
            this.renderToggleLink(),
            React.createElement(SlideUpPanel, { closeable: true, onClose: this.onToggleClick, open: open },
                React.createElement(SlideUpPanel.Content, null,
                    React.createElement(LegendsItems, null)))));
    }
    renderPopover() {
        const { open } = this.state;
        return (React.createElement(Popover, { alignment: Alignment.LEFT, className: "c-legends__popover", onClose: this.onToggleClick, open: open, placement: Placement.BOTTOM },
            this.renderToggleLink(),
            React.createElement(Popover.Content, null,
                React.createElement(LegendsItems, null))));
    }
    renderToggleLink() {
        const { hideExpression = Legends_1.defaultProps.hideExpression, showExpression = Legends_1.defaultProps.showExpression, } = this.props;
        const { open } = this.state;
        const linkValue = MessageService.translate(open ? hideExpression : showExpression);
        return (React.createElement(Link, { className: "c-legends__link", onClick: this.onToggleClick, value: linkValue }));
    }
    renderContent() {
        const { children, ...otherProps } = this.props;
        if (!children || Children.count(children) === 0) {
            return null;
        }
        const lostProps = getLostProps(Legends_1.propTypes, otherProps);
        return (React.createElement("div", { className: "c-legends__content" }, propagateProps(children, lostProps)));
    }
    renderLegends() {
        const { mode = Legends_1.defaultProps.mode } = this.props;
        const renderFn = this.renderMode[mode];
        return (React.createElement("div", { className: "c-legends__wrapper" }, renderFn()));
    }
    render() {
        const { className, mode = Legends_1.defaultProps.mode, size = Legends_1.defaultProps.size, uuid = Legends_1.defaultProps.uuid } = this.props;
        const legendsClassName = classNames({
            'c-legends': true,
            [`c-legends--${mode}`]: isEnumValid(LegendsMode, mode),
            [`${className}`]: Boolean(className),
        });
        return (React.createElement(LegendsProvider, { size: size },
            React.createElement(Container, { className: legendsClassName, uuid: uuid },
                this.renderContent(),
                this.renderLegends())));
    }
};
Legends.propTypes = {
    className: string,
    hideExpression: expression,
    mode: oneOf(enumValues(LegendsMode)),
    previewAmount: number.group('preview'),
    showExpression: expression,
    showPreview: bool.group('preview'),
    size: oneOf(enumValues(LegendsSize)),
};
Legends.defaultProps = {
    hideExpression: 'tws.legends.hide',
    mode: LegendsMode.INLINE,
    previewAmount: 2,
    showExpression: 'tws.legends.show',
    showPreview: false,
    size: LegendsSize.NORMAL,
    uuid: '',
};
Legends = Legends_1 = __decorate([
    AwesomeComponent({ api: LegendsAPI, containers: [LegendsContainer], type: ComponentType.DATA_DISPLAY })
], Legends);
export { Legends, };
//# sourceMappingURL=legends.js.map